export { ParcelLabWidget } from './ParcelLabWidget'
export type { ParcelLabWidgetProps } from './types'
